import { render } from "./doctor-profile.vue?vue&type=template&id=193f51ed"
import script from "./doctor-profile.vue?vue&type=script&lang=js"
export * from "./doctor-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__